/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'jsm.attachment-field.attachment-permission-error': 'Contact your admin to grant you permission to attach files.',
  'jsm.attachment-field.browse-with-dropzone': 'Drop files to attach or<a>browse</a>',
  'jsm.attachment-field.create.uploadError': 'Error uploading attachment',
  'jsm.attachment-field.create.uploadErrorDescription': 'An error occurred when uploading an attachment',
  'jsm.attachment-field.create.uploadErrorForSizeLimit':
    "There can't be more than 50 attachments on a form at any given time.",
  'jsm.attachment-field.default-render-error':
    'Unable to show attachments in this field. Refresh this page to try again.',
  'jsm.attachment-field.missing-token': 'Something went wrong',
  'jsm.attachment-field.preview-field.attachment-upload': 'Attachments will be uploaded here',
  'jsm.attachment-field.services.delete-failed-description':
    'There was a connection problem and the attachment was not successfully deleted. Try checking your network connection.',
  'jsm.attachment-field.services.delete-failed-title': 'Attachment could not be deleted',
  'jsm.attachment-field.services.download-failed-description':
    'We didn’t finish downloading your attachments for {issueKey}. Check your connection and then try again.',
  'jsm.attachment-field.services.download-failed-exceed-file-size-description':
    "The total size of {issueKey}'s attachments is too large to download. Try downloading each attachment individually.",
  'jsm.attachment-field.services.download-failed-title': 'We couldn’t download your attachments',
  'jsm.attachment-field.services.download-start-description':
    'This might take a while. When we’re done, your attachments will be in a zip file on your device.',
  'jsm.attachment-field.services.download-start-title': 'Downloading attachments',
  'jsm.attachment-field.services.got-it': 'Got it',
  'jsm.attachment-field.services.try-again': 'Try again',
  'jsm.attachment-field.shared-viewer.emptyState': 'No attachments uploaded',
};
